import VueLogger from 'vuejs-logger';
import Vue from 'vue';

const isProduction = process.env.NODE_ENV === 'production';

const options = {
    isEnabled: !isProduction,
    logLevel : isProduction ? 'error' : 'debug',
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : true,
    separator: '|',
    showConsoleColors: true
};

Vue.use(VueLogger, options);

export default {}